import { observer } from 'mobx-react';
import React from 'react';
import { localeStore } from '~/mobx/localesStore';
import Button from '~/view/components/Controls/ButtonComponent/Button';

interface IVatLabelProps {
  onClick: () => void;
}

const SetToDefaultButton: React.FC<IVatLabelProps> = observer(({ onClick }: IVatLabelProps): JSX.Element => {
  return <Button title={localeStore.t('reset_to_global_price')} onClick={onClick} appearance="tertiary" className="ml-2" />;
});

export default SetToDefaultButton;
